import React, { useState, useCallback } from "react";

import Header from "./Header";
import Sidebar from "./Sidebar";

type LayoutProps = {};

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [visibility, setVisibility] = useState(false);

  const handleSidebarShow = useCallback(() => setVisibility(true), []);
  const handleSidebarHide = useCallback(() => setVisibility(false), []);

  return (
    <div className="flex h-screen overflow-hidden font-sans bg-white print:overflow-visible">
      <Sidebar
        visible={visibility}
        onHide={handleSidebarHide}
        stripped={false}
      />
      <div className="flex flex-col flex-1 w-0 overflow-hidden print:overflow-visible">
        <Header onVisibilityChange={handleSidebarShow} />
        <main
          className="relative flex flex-1 overflow-y-hidden print:overflow-y-visible focus:outline-none"
          tabIndex={0}
        >
          <div className="flex flex-grow overflow-y-auto">{children}</div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
